<script setup lang="ts">
import { useModule } from "@/stores/module";
import { Worldview } from "@/types/entity";
import { showSuccessToast } from "vant";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  worldviewUuid: string;
  uuid: string;
}>();

const emit = defineEmits<{
  (e: "close"): void;
}>();

const origin = window.location.origin;
const { t } = useI18n();
const isSaving = ref(false);

const moduleStore = useModule();

const onReceiveMessage = async (event: MessageEvent) => {
  const { data } = event;
  if (!data || typeof data !== "string") {
    return;
  }
  const payload = JSON.parse(data);
  const type = payload.type;
  const media = JSON.parse(payload.media);
  if (type === "upload_media") {
    (moduleStore.module!.entity as Worldview).mediaId = media.id;
    (moduleStore.module!.entity as Worldview).media = media;
    showSuccessToast(t("Message.saveSuccess"));
    emit("close");
  }
};

onMounted(() => {
  window.addEventListener("message", onReceiveMessage, false);
});
</script>
<template>
  <div class="h-full overflow-hidden grid grid-rows-[1fr] relative">
    <iframe
      :src="`${origin}/planet-generator/?uuid=${uuid}&worldviewUuid=${worldviewUuid}`"
      class="w-full h-full"
    />
    <div
      class="absolute top-3 right-2 flex items-center gap-4 bg-white/20 rounded-full p-1 justify-center border border-white/30"
      v-if="!isSaving"
      @click="emit('close')"
    >
      <i class="iconify mingcute--close-line text-white text-xs" />
    </div>
  </div>
</template>
